import { render, staticRenderFns } from "./InfoCard.vue?vue&type=template&id=4e7f1592&scoped=true&"
import script from "./InfoCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./InfoCard.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./InfoCard.vue?vue&type=style&index=0&id=4e7f1592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7f1592",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e7f1592')) {
      api.createRecord('4e7f1592', component.options)
    } else {
      api.reload('4e7f1592', component.options)
    }
    module.hot.accept("./InfoCard.vue?vue&type=template&id=4e7f1592&scoped=true&", function () {
      api.rerender('4e7f1592', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/about-us/index/components/MainContent/components/InfoCard.vue"
export default component.exports